module.exports = __webpack_public_path__ + "static/feature-1-73cca35d0dfa75ef79dd6033be1d2763.jpg";